module.exports = __webpack_public_path__ + "static/human_female_barbarian-e8389677c356c5376e9c2d5baf3e0062.png";